export default {
  backUpPlusTitle: {
    id: 'backup_plus_radio_title',
    defaultMessage: 'Backup',
  },
  tagLabel: {
    id: 'backup_plus_radio_tag',
    defaultMessage: 'Max protection',
  },
  plusSign: {
    id: 'backup_plus_radio_plus_sign',
    defaultMessage: '+',
  },
  backupBenefitIncluded: {
    id: 'backup_plus_radio_benefit_included',
    defaultMessage: 'Everything in BackUp, {plus, html}:',
  },
  backupBenefitIncludedPlus: {
    id: 'backup_plus_radio_benefit_included_plus',
    defaultMessage: 'plus',
  },
  benefit1: {
    id: 'backup_plus_radio_benefit_1',
    defaultMessage: 'Unlimited repairs',
  },
  benefit2: {
    id: 'backup_plus_radio_benefit_2',
    defaultMessage: 'Battery replacement anytime in year 2',
  },
}
